import { BodyText, Caption } from '@kvdbil/components';
import { ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Icon = styled.div`
  font-size: 1.5rem;
`;

interface AccountInformationRowProps {
  title?: string;
  subtitle: ReactNode;
  icon: ReactNode;
}

const AccountInformationRow = ({
  icon,
  title = '--',
  subtitle = '--',
}: AccountInformationRowProps) => {
  return (
    <Container>
      <Icon>{icon}</Icon>
      <TextContainer>
        <BodyText data-testid="email">{title}</BodyText>
        {typeof subtitle === 'string' ? (
          <Caption>{subtitle}</Caption>
        ) : (
          subtitle
        )}
      </TextContainer>
    </Container>
  );
};

export default AccountInformationRow;
